import { find, filter, get, groupBy, orderBy, map, uniq, kebabCase } from 'lodash'

const _ALL = typeof Symbol === 'function' ? Symbol('_ALL') : '_ALL'
const _ARTICLES = typeof Symbol === 'function' ? Symbol('_ALL') : '_ALL'
const _DOCUMENTS = typeof Symbol === 'function' ? Symbol('_ALL') : '_ALL'
const _LINKURIOUS = typeof Symbol === 'function' ? Symbol('_ALL') : '_ALL'

export class PlayerFactory {
  constructor () {
    this[_ALL] = get(require(`@/data/${this.currentLanguage}`), 'players', [])
    this[_ARTICLES] = get(require('@/data/articles'), 'articles', [])
    this[_DOCUMENTS] = get(require('@/data/documents'), 'documents', [])
    this[_LINKURIOUS] = get(require('@/data/linkurious'), 'linkurious', [])
  }
  get currentLanguage () {
    let validate_path = (window.location.pathname).split("/")
    if(process.env.NODE_ENV === 'production') {
      validate_path = window.location.pathname.replace('/investigations/pandora-papers/power-players').split("/")
    }

    if(['es','en'].includes(validate_path[1])) {
      if(validate_path[1] === 'es')
        return `index_es`
    }

    return `index`
  }
  get all () {

    let players = map(this[_ALL], p => {
      if(p.linked) {
        p.linked_list = map(p.linked.split(';'), r => {
          const values = r.split("|")
          return {
            id: `${p.id}_${values[0]}`,
            name: values[1]
          }
        })
      }

      const articles = filter(this[_ARTICLES], ['profile_id', p.id])
      const documents = filter(this[_DOCUMENTS], ['profile_id', p.id])

      if(p.data_unit_id) {
        const linkurious = find(this[_LINKURIOUS], ['title_folder', p.data_unit_id])
        if(linkurious) {
          p.linkurious = linkurious.widget_url
        }
      }
      
      if(articles) {
        p.articles = articles
      }
      
      if(documents) {
        p.documents = documents
      }

      if(p.extra_linkurious) {
        const list = p.extra_linkurious.split(";")

        p.extra_linkurious_links = list.map(item => {
          const link = item.split(":")
          const url = find(this[_LINKURIOUS], ['title_folder', link[0]])
          if(url) {
            return {
              id: link[0],
              name: link[1],
              link: url.widget_url
            }
          }
        })
      }

      return p
    })

    return players
  }
  get providers () {

    let providersList = []

    map(this.ordered, player => {
      if(player.provider) {
        let pList = player.provider.split(";")
        map(pList, p => {
          const new_provider = {}
          new_provider.provider_id = kebabCase(p)
          new_provider.url = kebabCase(p)
          new_provider.provider = p
          new_provider.player = player
          providersList.push(new_provider)
        })  
      }     
    })

    return map(groupBy(providersList, 'provider_id'), (players, id) => {
      return {
        provider_id: id,
        provider: uniq(map(players, 'provider')).join(""),
        players: map(players, p => {
          return p.player
        })
      }
    })

  }
  get countries () {

    let countriesList = []

    map(this[_ALL], player => {
      if(player.other_countries) {
        let pList = player.other_countries.split(",")
        map(pList, cvalues => {
          const new_player = {}
          new_player.country_link_id = kebabCase(cvalues)
          new_player.country_link_url = kebabCase(cvalues)
          new_player.country_link = cvalues
          new_player.player = player
          countriesList.push(new_player)
        })  
      }     
    })

    return map(groupBy(countriesList, 'country_link_id'), (players, id) => {
      return {
        country_id: id,
        country: uniq(map(players, 'country_link')).join(""),
        country_url: uniq(map(players, 'country_link_url')).join(""),
        players: map(players, p => {
          return p.player
        })
      }
    })

  }
  get regions () {

    return map(groupBy(this.ordered, this.regionField), (players, region_id) => {
      return {
        region_id: region_id,
        region: uniq(map(players, 'region')).join(""),
        players: map(players, p => {
          p.url = kebabCase(p.short_name)
          return p
        })
      }
    })
  }
  get ordered () {
    return orderBy(this[_ALL], player => player[this.rankingField])
  }
  get filtered () {
    return this.ordered
  }
  get rankingField () {
    return 'ranking'
  }
  get regionIdField () {
    return 'region_id'
  }
  get regionField () {
    return 'region_id'
  }
  get titleField () {
    return 'short_name'
  }
  get countryField () {
    return 'other_countries'
  }
  get providerField () {
    return 'provider'
  }
  get providerIdField () {
    return 'provider_id'
  }
  get countryIdField () {
    return 'country_id'
  }
  filterByProvider (value) {
    const provider = find(this.providers, [this.providerIdField, value])
    return provider.players
  }
  filterByCountry (value) {
    const country = find(this.countries, [this.countryIdField, value])
    return country.players
  }
  filterByRegion (value) {
    const region = find(this.regions, [this.regionField, value])
    return region.players
  }
  static create () {
    return new PlayerFactory()
  }
}

export default new PlayerFactory()
